'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
require('styled-components');
require('lodash/get');
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
require('../shared-components.js');
require('lodash/camelCase');
require('lodash/upperFirst');
require('../icon.js');
var select = require('./select.js');
var constants = require('../constants-53160533.js');

var USStateDropdown = function USStateDropdown(props) {
  return React__default.createElement(select.default, _babelHelpers._extends({}, props, {
    options: constants.US_STATES.filter(function (state) {
      return !(props.omittedStates || []).includes(state.value);
    }).map(function (state) {
      return {
        label: state.label,
        value: state.value
      };
    }),
    label: "State"
  }));
};
USStateDropdown.propTypes = {
  /** component id */
  id: PropTypes$1.string.isRequired,
  /** indicator to display red sign */
  isRequired: PropTypes$1.bool,
  /** indicator to display disable dropdown */
  disabled: PropTypes$1.bool,
  /** error message to display under dropdown */
  error: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.string]),
  /** dropdown width */
  width: PropTypes$1.string,
  /** dropdown height */
  height: PropTypes$1.string,
  /** text color of label */
  textColor: PropTypes$1.string,
  /** style to override label component */
  labelStyle: PropTypes$1.object,
  /** states that will be omitted from the list */
  omittedStates: PropTypes$1.array,
  /** style to override error message component */
  ErrorMessageStyle: PropTypes$1.object
};
USStateDropdown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "USStateDropdown",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "component id"
    },
    "isRequired": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display red sign"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display disable dropdown"
    },
    "error": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "error message to display under dropdown"
    },
    "width": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "dropdown width"
    },
    "height": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "dropdown height"
    },
    "textColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text color of label"
    },
    "labelStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "style to override label component"
    },
    "omittedStates": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "states that will be omitted from the list"
    },
    "ErrorMessageStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "style to override error message component"
    }
  }
};

module.exports = USStateDropdown;
//# sourceMappingURL=us-state.js.map
